import { selectFromPlanningActionsSubscription } from '../models';
import { SubscriptionHandler } from '../utils/createSubscription';
import defaultHandler from './handlers/planningActions/defaultHandler';
import deleteRoutesHandler from './handlers/planningActions/deleteRoutesHandler';
import optimizeHandler from './handlers/planningActions/optimizeHandler';
import duplicateRouteHandler from './handlers/planningActions/duplicateRouteHandler';
import ordersToTargetRoutesHandler from './handlers/planningActions/ordersToTargetRoutesHandler';

const selector = selectFromPlanningActionsSubscription()
  .planningActionMetadataDeleteRoutesDto(p => p
    .actionUuid.projectId.startDate.actionName.status.userUuid.createdAt.updatedAt.finishedAt.isRedo.isUndo
    .output(o => o.error.details(m => m.orderDeliveryDateMetadataDto(n => n.earliestDate.unscheduledOrdersCount)))
    .childActions(c => c.routeActionDto(r => r.actionUuid.name.routeUuid.status).visitActionDto(v => v.actionUuid.name.status.eventUuids)))
  .planningActionMetadataOptimizeDateDto(p => p.actionUuid.projectId.startDate.actionName.status.detail.userUuid.createdAt.updatedAt.finishedAt
    .output(o => o.error.details(d => d.scheduleActionMetadataDto(s => s.scheduledOrdersCount.newScheduledOrdersCount.unscheduledOrdersCount
      .unscheduledDueToTimeWindowShorterThanDuration
      .ignored_features(i => i.has_balance.has_capacities).time_of_day_eta_applied
      .error(e => e.code.details(de => de.violations))))))
  .planningActionMetadataOptimizeOrdersToTargetRoutesDto(p => p.actionUuid.projectId.startDate.actionName.status.detail.userUuid.createdAt.updatedAt.finishedAt.isUndo
    .output(o => o.error.details(d => d.scheduleActionMetadataDto(s => s.scheduledOrdersCount.unscheduledOrdersCount
      .unscheduledDueToTimeWindowShorterThanDuration.error(e => e.code.details(de => de.violations))))))
  .planningActionMetadataMoveOrdersToRoutesDto(p => p.actionUuid.projectId.startDate.actionName.status.detail.userUuid.createdAt.updatedAt.finishedAt.isUndo
    .output(o => o.error.details(d => d.scheduleActionMetadataDto(s => s.unscheduledOrdersCount.newScheduledOrdersCount.isScheduleAll
      .unscheduledDueToTimeWindowShorterThanDuration
      .error(e => e.code.details(de => de.violations))))))
  .planningActionMetadataReOptimizeDto(p => p.actionUuid.projectId.startDate.actionName.status.detail.userUuid.createdAt.updatedAt.finishedAt
    .output(o => o.error.details(d => d.scheduleActionMetadataDto(s => s.scheduledOrdersCount.unscheduledOrdersCount
      .unscheduledDueToTimeWindowShorterThanDuration
      .ignored_features(i => i.has_balance.has_capacities).time_of_day_eta_applied))))
  .planningActionMetadataDrawRouteDto(p => p.actionUuid.projectId.startDate.actionName.status.detail.userUuid.createdAt.updatedAt.finishedAt
    .output(o => o.error.details(d => d.scheduleActionMetadataDto(s => s.scheduledOrdersCount.unscheduledOrdersCount
      .unscheduledDueToTimeWindowShorterThanDuration
      .ignored_features(i => i.has_balance.has_capacities).time_of_day_eta_applied))))
  .planningActionMetadataReOptimizeTargetRouteDto(p => p.actionUuid.projectId.startDate.actionName.status.detail.userUuid.createdAt.updatedAt.finishedAt
    .output(o => o.error.details(d => d.scheduleActionMetadataDto(s => s.scheduledOrdersCount.unscheduledOrdersCount
      .unscheduledDueToTimeWindowShorterThanDuration
      .ignored_features(i => i.has_balance.has_capacities).time_of_day_eta_applied))))
  .planningActionMetadataDuplicateRoutesDto(p => p
    .actionUuid.projectId.startDate.actionName.status.userUuid.createdAt.updatedAt.finishedAt.isRedo.isUndo
    .output(o => o.error))
  .planningActionMetadataDto(p => p.actionUuid.actionName.status.userUuid.createdAt.updatedAt.finishedAt.projectId
    .output(o => o.error.details(m => m.orderDeliveryDateMetadataDto(n => n.earliestDate.unscheduledOrdersCount))))
  .toString();

export default (): SubscriptionHandler => ({
  name: 'PlanningActionsSubscription',
  selector,
  events: new Map(Object.entries({
    PlanningActionMetadataDeleteRoutesDto: [deleteRoutesHandler],
    PlanningActionMetadataOptimizeDateDto: [optimizeHandler],
    PlanningActionMetadataReOptimizeDto: [optimizeHandler],
    PlanningActionMetadataDrawRouteDto: [optimizeHandler],
    PlanningActionMetadataReOptimizeTargetRouteDto: [defaultHandler],
    PlanningActionMetadataOptimizeOrdersToTargetRoutesDto: [ordersToTargetRoutesHandler],
    PlanningActionMetadataMoveOrdersToRoutesDto: [ordersToTargetRoutesHandler],
    PlanningActionMetadataDuplicateRoutesDto: [duplicateRouteHandler],
    PlanningActionMetadataDto: [defaultHandler],
  })),
  onError(error: Error) {
    console.error('PlanningActionsSubcription Error, check if websocket client initialized', JSON.stringify(error));
  },
});
